module.exports = __webpack_public_path__ + "img/check_info.5190849d.png";